//const refs = 'menu'
export default [
    // { 
    //     path: '/aboutus', 
    //     name: 'aboutus', 
    //     component: () => import('@/views/aboutUs/List.vue')
    // },

]